import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { user, login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) nav("/admin");
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16 animate-fade-in" data-testid="login-page">
      <p className="section-eyebrow">PANEL EDITORIAL</p>
      <h1 className="font-serif-display text-5xl mt-2 mb-2">Iniciar sesión</h1>
      <p className="text-sm text-sub mb-8">Sólo editores de POLÍTICA REAL.</p>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <div>
          <label className="font-mono text-[11px] uppercase tracking-widest text-sub">Correo</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="mt-1 w-full bg-transparent border border-ink/30 focus:border-ink outline-none px-3 py-2 font-sans text-sm rounded-none"
            data-testid="login-email"
          />
        </div>
        <div>
          <label className="font-mono text-[11px] uppercase tracking-widest text-sub">Contraseña</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="mt-1 w-full bg-transparent border border-ink/30 focus:border-ink outline-none px-3 py-2 font-sans text-sm rounded-none"
            data-testid="login-password"
          />
        </div>
        {error && <p className="text-sm text-rojo font-sans" data-testid="login-error">{error}</p>}
        <button
          type="submit"
          disabled={loading}
          className="w-full border border-ink py-2 font-mono text-[12px] uppercase tracking-widest hover:bg-ink hover:text-paper transition-colors disabled:opacity-40"
          data-testid="login-submit"
        >
          {loading ? "Entrando…" : "Entrar"}
        </button>
      </form>
    </div>
  );
}
